import { render, staticRenderFns } from "./HeaderInformationNavigationNcph.vue?vue&type=template&id=3abce890&scoped=true"
import script from "./HeaderInformationNavigationNcph.vue?vue&type=script&lang=ts"
export * from "./HeaderInformationNavigationNcph.vue?vue&type=script&lang=ts"
import style0 from "./HeaderInformationNavigationNcph.vue?vue&type=style&index=0&id=3abce890&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3abce890",
  null
  
)

export default component.exports